import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Paginatable } from '@/modules/shared/helpers/http/paginatable'
import { Paginated } from '@/modules/shared/models/data'

@Component
export class SearchablePaginatableMixin<T> extends Vue {
  protected get paginatable(): Paginatable<Paginated<T>> {
    throw new Error('must override paginatable')
  }

  protected get loading(): boolean {
    return this.paginatable.isInProgress()
  }

  search(needle: string, update: () => void = () => {
  }, params?) {
    if (
      !this.loading
    ) {
      this.paginatable
        .search(needle, params)
        .onChange(
          event => update()
        )
    } else {
      update()
    }
  }
}
